/**
 * BANK-IBAN-R3.10 — unregister obsolete Customer SW / CacheStorage once.
 * Does not clear unrelated browser data.
 */
const ONCE_KEY = "asiastyle.r310.sw-cleared";

export function clearObsoleteCustomerServiceWorkerOnce(): void {
  try {
    if (sessionStorage.getItem(ONCE_KEY) === "1") return;
    sessionStorage.setItem(ONCE_KEY, "1");
  } catch {
    /* continue */
  }
  if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
    void navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const reg of regs) void reg.unregister();
    });
  }
  if (typeof caches === "undefined") return;
  void caches.keys().then((keys) => {
    for (const key of keys) {
      if (/asiastyle|store-v2|workbox|precache|mini-app/i.test(key)) {
        void caches.delete(key);
      }
    }
  });
}
